/*
 * Replaces alpha channgel value of given RGBA color.
 * @param {String} color - value in rgba format.
 * @param {Number} alpha - alpha channel value.
 */
export const opacityModifier = (color: string, alpha = 1) => {
  return color.replace(/[^,]+(?=\))/, alpha.toString());
};
